interface StatusPipProps {
  tone?: "ok" | "warn" | "error" | "muted" | "info";
  pulse?: boolean;
  className?: string;
}

const toneClass: Record<NonNullable<StatusPipProps["tone"]>, string> = {
  ok: "bg-primary-fixed-dim",
  warn: "bg-tertiary-container",
  error: "bg-error",
  muted: "bg-outline",
  info: "bg-secondary",
};

/** Small solid status circle, per DESIGN.md "Chips/Badges" guidance. */
export function StatusPip({ tone = "ok", pulse = false, className = "" }: StatusPipProps) {
  return (
    <span
      className={`inline-block w-1.5 h-1.5 rounded-full ${toneClass[tone]} ${pulse ? "animate-pulse" : ""} ${className}`}
    />
  );
}
